import { ArrowLongLeftIcon } from '@heroicons/react/20/solid';
import React from 'react';
import { useCartStore } from '@/ui/store/cart';
import { useTranslations } from 'next-intl';
import { CartValueSection } from '../CartValueSection';
import { AddedToCart } from '../AddedToCartBar';

export function CartTopBar({ onBackClick }: { onBackClick: () => void }) {
  const t = useTranslations('CartTopBar');

  const { isEmpty, lastAddedToCart } = useCartStore();
  return (
    <div className="bg-white pt-4">
      <div className="flex items-start justify-between">
        <div className="flex h-6 items-center">
          <button
            type="button"
            className="flex items-center gap-2 font-medium"
            onClick={onBackClick}
          >
            <ArrowLongLeftIcon className="h-8 w-8 text-primary-100" />
            {t('Continue Shopping')}
          </button>
        </div>
      </div>

      {lastAddedToCart && !isEmpty() && <AddedToCart productName={lastAddedToCart.name} />}

      {!isEmpty() && <CartValueSection />}
    </div>
  );
}
